import React, { useState, useEffect } from 'react';
import './LeadPopup.css';
import { FaTimes, FaRocket, FaCheckCircle } from 'react-icons/fa';
import BASE_URL from '../apiConfig';
import useRecaptcha from '../hooks/useRecaptcha';

function LeadPopup({ isOpen, onClose }) {
    const [formData, setFormData] = useState({
        full_name: '',
        phone: '',
        email: '',
        organization: '',
        challenges: ''
    });
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState('');
    const [widgetId, setWidgetId] = useState(null);
    const { getResponse } = useRecaptcha();

    useEffect(() => {
        if (isOpen && window.grecaptcha) {
            const timer = setTimeout(() => {
                const container = document.getElementById("recaptcha-popup-lead");
                if (container && container.innerHTML === "") {
                    try {
                        const id = window.grecaptcha.render(container, {
                            // sitekey: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI",
                             sitekey: window.RECAPTCHA_SITE_KEY,
                        });
                        setWidgetId(id);
                    } catch (err) {
                        console.error("reCAPTCHA LeadPopup render error:", err);
                    }
                }
            }, 500);
            return () => clearTimeout(timer);
        }
    }, [isOpen]);

    if (!isOpen) return null;

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            const token = getResponse(widgetId);
            if (!token) {
                setError("❌ Please complete the reCAPTCHA");
                setLoading(false);
                return;
            }

            const fd = new FormData();
            Object.keys(formData).forEach((key) => {
                fd.append(key, formData[key]);
            });
            fd.append('_type', 'get_started');
            fd.append('tk', token);

            const res = await fetch(`${BASE_URL}/DemoApi/saveData`, {
                method: 'POST',
                body: fd,
            });

            const result = await res.json();

            if (result.status) {
                setSubmitted(true);
                setTimeout(() => {
                    onClose();
                    setSubmitted(false);
                    setFormData({
                        full_name: '',
                        phone: '',
                        email: '',
                        organization: '',
                        challenges: ''
                    });
                }, 3000);
            } else {
                setError("❌ " + (result.message || "Verification Failed"));
            }
        } catch (err) {
            console.error("Submission Error:", err);
            setError('❌ Submission Failed. Check Console.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="lead-modal-overlay">
            <div className="lead-modal-content animate-zoomIn">
                <button className="close-modal-btn" onClick={onClose}>
                    <FaTimes />
                </button>

                {!submitted ? (
                    <>
                        <div className="modal-header-lead">
                            <div className="modal-icon-lead">
                                <FaRocket />
                            </div>
                            <h3>Get Started with IGNOSI</h3>
                            <p>Experience the future of banking. Our team will reach out to you within 24 hours.</p>
                        </div>

                        <form className="lead-modal-form" onSubmit={handleSubmit}>
                            <div className="input-group-lead">
                                <input
                                    type="text"
                                    name="full_name"
                                    placeholder="Full Name*"
                                    required
                                    value={formData.full_name}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="input-row-lead">
                                <input
                                    type="text"
                                    name="phone"
                                    placeholder="Phone Number*"
                                    required
                                    value={formData.phone}
                                    onChange={handleChange}
                                />
                                <input
                                    type="email"
                                    name="email"
                                    placeholder="Work Email"
                                    value={formData.email}
                                    onChange={handleChange}
                                />
                            </div>

                            <input
                                type="text"
                                name="organization"
                                placeholder="Organization / Institution Name"
                                value={formData.organization}
                                onChange={handleChange}
                            />

                            <textarea
                                name="challenges"
                                placeholder="Briefly describe your requirements or challenges..."
                                value={formData.challenges}
                                onChange={handleChange}
                            ></textarea>

                            <div
                                id="recaptcha-popup-lead"
                                style={{ marginBottom: "15px" }}
                            ></div>

                            <button type="submit" className="submit-lead-btn" disabled={loading}>
                                {loading ? 'Processing...' : 'Get Started Now'}
                            </button>

                            {error && <p className="error-msg-lead">{error}</p>}
                        </form>
                    </>
                ) : (
                    <div className="success-modal-lead animate-fadeIn">
                        <div className="success-icon-lead">
                            <FaCheckCircle />
                        </div>
                        <h3>Thank You!</h3>
                        <p>Your request has been received. Let's build something great together.</p>
                    </div>
                )}
            </div>
        </div>
    );
}

export default LeadPopup;
